import { Helmet } from 'react-helmet'
import React from 'react'
import { Box, Button, Card, Container, Typography } from '@mui/material'
// import { useLocation } from 'react-router-dom'
import useAppUtilities from '../../hooks/useAppUtilities'
import { ROUTES } from '../../helpers/routes-helper'

const BillingSuccessPage: React.FC = () => {
  const { navigate } = useAppUtilities()
  // const location = useLocation()

  // Optional: read session_id if we ever want to show it or call backend
  // const searchParams = new URLSearchParams(location.search)
  // const sessionId = searchParams.get('session_id')

  const handleGoToWallet = (): void => {
    navigate(`${ROUTES.PROFILE}?tab=Wallet`)
  }

  const handleGoToPoints = (): void => {
    navigate(ROUTES.POINTS)
  }

  return (
    <Container component="main" sx={{ flex: 1, py: { xs: 4, md: 6 } }}>
      <Helmet><title>Resactly | Payment Successful</title></Helmet>
      <Box sx={{ maxWidth: 600, mx: 'auto' }}>
        <Typography variant="h3" component="h1" color="text.primary" gutterBottom sx={{ mb: 3 }}>
          Subscription successful 🎉
        </Typography>
        <Card
          sx={{
            p: 3,
            borderRadius: '16px',
            backgroundColor: 'background.paper',
          }}
        >
          <Typography variant="body1" color="text.primary" sx={{ mb: 2 }}>
            Your subscription is being activated. Your account will be updated with full
            access to point redemptions in just a moment.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            You can now go to your wallet to view your points and redemption options.
          </Typography>
          {/* sessionId reserved for debugging/future use; do not display in UI for now */}
          <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }}>
            <Button
              variant="contained"
              fullWidth
              onClick={handleGoToWallet}
            >
              Go to Wallet
            </Button>
            <Button
              variant="outlined"
              fullWidth
              onClick={handleGoToPoints}
            >
              View Points
            </Button>
          </Box>
        </Card>
      </Box>
    </Container>
  )
}

export default BillingSuccessPage

